import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledMessage = styled(Flexbox)(
    ({theme: {palette, typography, spacing}}) => css`
        ${typography.textXs};
        background: ${palette.neutral['white']};
        border: 1px solid ${palette.neutral[200]};
        padding: ${spacing * 3}px;
        border-radius: 8px;
    `
)
